import { ReportEntry } from '@mbrtargeting/metatag-shared-types';
import { ReplaySubject, simpleStorageSwitch } from '@mbrtargeting/metatag-utils';
import { ReportEntriesStore } from '../utils/report-entries-store.js';

export const reportEntries$ = new ReplaySubject<ReportEntry>(1e6);

const writeToIndexedDB = !!simpleStorageSwitch('sdgWriteErrorLogToIndexedDB', /^(1|true)$/);

if (writeToIndexedDB) {
    new ReportEntriesStore().open()
        .then(store => {
            // delete entries older than 5 days
            store.truncate(5 * 24 * 60);
            // subscribe to report entries and add them to the IndexedDB store
            reportEntries$.subscribe(entry => store.add(entry));
        })
        .catch((error: unknown) => {
            console.error('failed to open store for report entries:', error);
        });
}
